import { render } from "./progress-bar.vue?vue&type=template&id=3f52182d&ts=true"
import script from "./progress-bar.vue?vue&type=script&lang=ts"
export * from "./progress-bar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__